import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { Autocomplete } from '../../../Autocomplete';

const getSelectedValue = (i, options, value) => {
  return i.isMulti && value
    ? options.filter(opt => value.includes(opt.value))
    : options.find(opt => opt.value == value);
};

const Select = ({
  classes,
  i,
  treeTrace,
  error,
  onChange,
  value,
  mode,
  defaultValue,
  excludeEmailOutFalse,
  fetchOptions,
  queryParamDefaultKey,
  isPrimaryEmailNull,

  ...rest
}) => {
  const {
    field,
    label,
    // options,
    noOptionsMessage,
    direction,
    disabledOnEdit,
    validate,
    disabled,
    isMulti,
    placeholder,
    defaultOptions,
    // loadOptions,
  } = i;

  const [options, setOptions] = useState([]);
  const [optionsLoading, setOptionsLoading] = useState(false);

  const fetchOptionsAsync = async (search = '', cb) => {
    // otherwise, fetch new

    try {
      setOptionsLoading(true);
      const searchTerm = search || undefined;
      const searchDefaultValue = search ? undefined : defaultValue;

      let optionResults = await fetchOptions({
        search: searchTerm,
        limit: 100,
        [queryParamDefaultKey]: searchDefaultValue,
      });

      // filter results if primaryEmailNull = true && underwriter.emailOutput = true
      //console.log(optionResults);
      optionResults =
        (excludeEmailOutFalse ?? false) == false
          ? optionResults
          : isPrimaryEmailNull
          ? optionResults.filter(x => x.emailOutput)
          : optionResults;

      //console.log(optionResults);

      setOptions(optionResults);

      setOptionsLoading(false);
      cb(optionResults);
      return optionResults;
    } catch (error) {
      console.log(error);
      setOptionsLoading(false);
      return [];
    }
  };

  const loadOptions = (text, cb, extra) => {
    if (!text) {
      fetchOptionsAsync(null, cb);
    } else if (text.length >= 3) {
      fetchOptionsAsync(text, cb);
    }
  };

  return (
    <Autocomplete
      {...i}
      {...rest}
      // options={options || []}
      // options={defaultOptions}
      defaultOptions={defaultOptions}
      disabled={disabled}
      // value={i.options.find(opt => opt.value === value)}
      value={getSelectedValue(i, options, value)}
      onChange={opt => {
        if (isMulti) {
          onChange(field, opt ? opt.map(o => o.value) : opt, treeTrace, i.onChange);
        } else {
          onChange(field, opt ? opt.value : opt, treeTrace, i.onChange);
        }
      }}
      placeholder={placeholder}
      error={error}
      // hideLabel={true}
      async
      loadOptions={loadOptions}
      loading={optionsLoading}
    />
  );
};

export default withStyles(styles)(Select);
